import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';
import { validatePassword } from '../../common/passwordValidator';
import { usePasswordReset } from '../../hooks';
import { IFormInput } from '../Form';
import LandingTemplate from '../LandingTemplate';

export default function PasswordReset() {
  const formHook = useForm();
  const { token } = useParams<{ token: string }>();

  const [resultMessage, setResultMessage] = useState<React.ReactNode>();

  const { resetPassword } = usePasswordReset();

  const inputs: IFormInput[] = [
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'password',
      validate: {
        password: value => validatePassword(value)
      },
      required: true
    }
  ];

  const successMessage = <>Password has been changed. Please <Link to='/login'>Login</Link>.</>;
  const failureMessage = <>It seems password reset link is expired or invalid. Password has not been changed. Please follow <Link to='/initiate-password-reset'>Reset Password</Link>.</>;

  const onSubmit = (data: any) => {
    resetPassword(data.newPassword, token)
      .then(() => setResultMessage(successMessage))
      .catch(processError);
  };

  function processError(error: AxiosError) {
    const { response } = error;

    if (response?.status === 422) {
      const { invalidToken } = response.data;

      if (invalidToken) {
        setResultMessage(failureMessage);
      }

      return;
    }
  }

  return <LandingTemplate
    form={{ submitCaption: "Reset Password", inputs, onSubmit, formHook }}
    successFullSubmitMessage={resultMessage}
  />;
}